export default __webpack_public_path__ + "static/recurring-payments-2dfae7e682276f01b8581fa51a887784.png";